import React from 'react';
import { GridDefaultCellTemplates } from '../../components/components/Grid/grid-template';
import { SelectOption } from '../../shared/components/input';
import { Button } from 'primereact/button';
import { CommonUtility } from '../../Services/CommonUtility';
import * as constant from '../../shared/util/constant';
import { CompensationRateLabels as label } from '../../shared/util/label';

export default class CompensationRateGridService {
    private ActionColumn = {
        CellTemplate: (cell: any) => {
            const disableButton = !!cell?.row?.original?.isGridInEditMode;
            const params = cell.column.CellEditTemplateParameters;
            const duplicateDisabled = disableButton || params?.disableDuplicate;
            const editDisabled = disableButton || params?.disableEdit;
            const deleteDisabled = disableButton || params?.disableDelete;
            return (
                <div className="compensation-rate-action-btns">
                    <span title={label.BTN_DUPLICATE}>
                        <Button
                            icon="bi bi-files"
                            onClick={() => {
                                if (!duplicateDisabled)
                                    params?.cellClickHandler(cell.row.original, cell.column, 'duplicate_row');
                            }}
                            disabled={duplicateDisabled}
                            size="small"
                            className="text-nowrap align-self-center customerTasks-buttons"
                        />
                    </span>
                    <Button
                        icon="bi bi-pencil"
                        onClick={() => {
                            if (!editDisabled)
                                params?.cellClickHandler(cell.row.original, cell.column, 'edit_row');
                        }}
                        disabled={editDisabled}
                        size="small"
                        className="text-nowrap align-self-center customerTasks-buttons"
                    />
                    <Button
                        icon="bi bi-trash"
                        onClick={() => {
                            if (!deleteDisabled)
                                params?.cellClickHandler(cell.row.original, cell.column, 'delete_row');
                        }}
                        disabled={deleteDisabled}
                        size="small"
                        severity="danger"
                        className="text-nowrap align-self-center customerTasks-buttons"
                    />
                </div>
            );
        },
    };

    public getGridColumns = (
        onEditingCellDataChange: (row: any, column: any, value: any, additionalInfo: any) => void,
        onOriginalRowDataChange: (row: any, fieldName: string, value: any) => void,
        cellClickHandler: (row: any, column: any, additionalData: any) => void,
        agencyOptions: SelectOption[],
        carrierOptions: SelectOption[],
        stateOptions: SelectOption[],
        policyTypeOptions: SelectOption[],
        lobOptions: SelectOption[],
        transactionTypeOptions: SelectOption[],
        disableDuplicate: boolean = false,
        disableEdit: boolean = false,
        disableDelete: boolean = false
    ): any[] => {
        return [
            {
                Header: label.ACTIONS,
                accessor: 'enableGridRowEditing',
                hideColumnFilter: true,
                headerClassName: 'sticky-col sticky-col-header',
                cellClassName: 'sticky-col',
                Cell: (cell: any) => {
                    if (cell.row?.original?.enableGridRowEditing)
                        return GridDefaultCellTemplates.SaveRowGridColumn.CellTemplate(cell);
                    return this.ActionColumn.CellTemplate(cell);
                },
                CellEditTemplateParameters: { cellClickHandler, disableDuplicate, disableEdit, disableDelete },
                CellEditTDProperties: { className: 'grd-edit-cell-td sticky-col' },
                width: 120,
            },
            {
                Header: label.AGENCY,
                accessor: 'agencyDescr',
                fieldName: 'agencyId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.agencyDescr}>{cell.row?.original?.agencyDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: agencyOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                    selectMainDivInvalidClassName: 'custom-dropdown--error-select-div',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 250,
            },
            {
                Header: label.CARRIER,
                accessor: 'carrierDescr',
                fieldName: 'carrierId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.carrierDescr}>{cell.row?.original?.carrierDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: carrierOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                    selectMainDivInvalidClassName: 'custom-dropdown--error-select-div',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 250,
            },
            {
                Header: label.STATE,
                accessor: 'state',
                fieldName: 'state',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span>{cell.row?.original?.state}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: stateOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 110,
            },
            {
                Header: label.POLICY_TYPE,
                accessor: 'policyTypeDescr',
                fieldName: 'policyTypeId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.policyTypeDescr}>{cell.row?.original?.policyTypeDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: policyTypeOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                    selectMainDivInvalidClassName: 'custom-dropdown--error-select-div',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 170,
            },
            {
                Header: label.LINE_OF_BUSINESS,
                accessor: 'lineOfBusinessDescr',
                fieldName: 'lineOfBusinessId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.lineOfBusinessDescr}>{cell.row?.original?.lineOfBusinessDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: lobOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 240,
            },
            {
                Header: label.TRANSACTION_TYPE,
                accessor: 'transactionTypeDescr',
                fieldName: 'transactionTypeId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.transactionTypeDescr}>{cell.row?.original?.transactionTypeDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: transactionTypeOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 180,
            },
            {
                Header: label.EFFECTIVE_DATE,
                accessor: 'effDateDisplay',
                fieldName: 'effDate',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span>{cell.row?.original?.effDateDisplay}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.DateFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, isPopperTop: true, popperProps: { strategy: 'fixed' } },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.DateFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 140,
            },
            {
                Header: label.RATE,
                accessor: 'rate',
                fieldName: 'rate',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => {
                    const val = cell.row?.original?.rate;
                    return <div>{val != null ? Number(val).toFixed(2) : ''}</div>;
                },
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    cellDataChangeHandler: onEditingCellDataChange,
                    type: 'number',
                    maxLength: 12,
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 120,
            },
            {
                Header: label.NOTES,
                accessor: 'notesShort',
                fieldName: 'notes',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => {
                    const originalRow = cell.row?.original;
                    const isExpanded = !!originalRow?.isNoteExpanded;
                    const fullNote = originalRow?.notes || '';
                    const shortNote = originalRow?.notesShort || '';
                    const hasMore = fullNote.length > shortNote.length;
                    const textToShow = isExpanded ? fullNote : shortNote;
                    return (
                        <div className="compensation-rate-note-cell">
                            <span title={fullNote}>{textToShow}</span>
                            {(hasMore || isExpanded) && (
                                <span
                                    className="btn btn-link p-0 text-primary text-decoration-none compensation-rate-note-toggle"
                                    onClick={() => onOriginalRowDataChange(originalRow, 'isNoteExpanded', !isExpanded)}
                                >
                                    {isExpanded ? ' ...less' : ' more'}
                                </span>
                            )}
                        </div>
                    );
                },
                CellEditTemplate: GridDefaultCellTemplates.TextFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, maxLength: 400 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 250,
            },
        ];
    };

    public getNewRow = (): any => {
        const base: any = {
            id: constant.DEFAULT_GUID,
            agencyId: '',
            carrierId: '',
            state: null,
            policyTypeId: '',
            lineOfBusinessId: null,
            transactionTypeId: null,
            effDate: null,
            effDateDisplay: '',
            rate: null,
            notes: null,
            notesShort: '',
            isNoteExpanded: false,
            agencyDescr: '',
            carrierDescr: '',
            policyTypeDescr: '',
            lineOfBusinessDescr: '',
            transactionTypeDescr: '',
            enableGridRowEditing: true,
            isGridInEditMode: false,
        };
        base.editingRow = { ...base };
        return base;
    };

    public enrichRow = (row: any): void => {
        row.effDateDisplay = row.effDate ? CommonUtility.formateDate(new Date(row.effDate)) : '';
        row.notesShort = row.notes || '';
        if (row.notes && row.notes.length > 40) {
            row.notesShort = CommonUtility.truncateString(row.notes, 40);
        }
        row.isNoteExpanded = false;
        row.enableGridRowEditing = false;
        row.isGridInEditMode = false;
    };

    public validateRow = (originalRow: any): any => {
        const er = originalRow.editingRow;
        const errors: any = {};
        if (!er?.agencyId?.trim())
            errors['agencyId'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        if (!er?.carrierId?.trim())
            errors['carrierId'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        if (!er?.policyTypeId?.trim())
            errors['policyTypeId'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        if (er?.rate == null || er?.rate === '')
            errors['rate'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        return errors;
    };
}
